<template>
  <div class="notice_mng">
    <h2 class="title_com">日报管理</h2>
    <section class="pd2430">
      <!-- 搜索 -->
      <el-form
        :model="formData"
        ref="form"
        :inline="true"
        label-width="100px"
        class="form-box mb25"
      >
        <el-form-item label="创建日期：" prop="start_date">
          <el-date-picker
            v-model="formData.start_date"
            type="date"
            placeholder="选择日期"
            size="small"
          >
          </el-date-picker>
        </el-form-item>

        <el-form-item label="状态：" prop="submit">
          <el-select
            v-model="formData.submit"
            placeholder="请选择状态"
            clearable
            filterable
            :style="{ width: '100%' }"
            size="small"
          >
            <el-option
              v-for="(item, index) in statusOptions"
              :key="index"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label=" ">
          <el-button type="primary" size="small" @click="formQuery()">查询</el-button>
          <el-button size="small" @click="formReset('form')">重置</el-button>
        </el-form-item>
      </el-form>

      <ComTable ref="table" :filter="formData" :api="tableApi">
        <ComTableColumn
          prop="start_date"
          label="创建日期"
          header-align="center"
          align="center"
        ></ComTableColumn>
        <ComTableColumn
          prop="submit_name"
          label="状态"
          header-align="center"
          align="center"
        ></ComTableColumn>
        <ComTableColumn
          label="操作"
          width="200"
          header-align="center"
          align="right"
          column_type="3"
        >
          <template scope="scope">
            <div class="public-table-column-operate">
              <el-link type="primary" :underline="false" @click="edit(scope.row)">
                编辑
              </el-link>
              <el-link type="primary" :underline="false" @click="download(scope.row)">
                导出word
              </el-link>
            </div>
          </template>
        </ComTableColumn>
      </ComTable>
    </section>
  </div>
</template>

<script>
import { getApiDailyList, getApiDailyDetails } from "@/api/tearcher";
export default {
  components: {},
  data() {
    return {
      tableApi: getApiDailyList, //表格接口
      //表单数据
      formData: {
        class_id: sessionStorage.getItem("class_id"),
        start_date: "",
        submit: "",
      },
      //状态选项
      statusOptions: [
        {
          label: "未编辑",
          value: 0,
        },
        {
          label: "保存",
          value: 1,
        },
        {
          label: "保存提交",
          value: 2,
        },
      ],
    };
  },
  methods: {
    //表格数据初始化
    initializeTable() {
      this.$refs["table"].initialize();
    },
    //表单查询
    formQuery() {
      this.initializeTable();
    },
    //表单重置
    formReset(formName) {
      this.$refs[formName].resetFields();
      this.initializeTable();
    },
    //编辑
    edit(e) {
      this.$router.push({
        path: "/DailyDetails",
        query: {
          id: e.id,
        },
      });
    },
    //导出word
    download(e) {
      getApiDailyDetails(e.id, { is_export: 1 }).then((res) => {
        if (res.error_code == 200) {
          let data = res.data;
          window.open(data);
        }
      });
    },
  },
  created() {},
};
</script>

<style lang="less" scoped>
.form-box {
  padding: 20px 0 10px 0;
  background: #f7f7f7;
  .el-form-item {
    margin-bottom: 10px;
  }
}
.operate-box {
  padding: 30px 0 10px 0;
}
</style>
